import { useCallback, useEffect, useState } from 'react';
import { centerAPI, getErrorMessage } from '../services/api';

export function useCenters({ activeOnly = false } = {}) {
  const [centers, setCenters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await centerAPI.listCenters({ activeOnly });
      setCenters(response.data.items || []);
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, [activeOnly]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { centers, loading, error, refresh };
}
